import { NgModule } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { MenubarModule } from 'primeng/menubar';
import { ToastModule } from 'primeng/toast';
import { DialogService, DynamicDialogModule } from 'primeng/dynamicdialog';
import { StyleClassModule } from 'primeng/styleclass';
import { TableModule } from 'primeng/table';
import { AccordionModule } from 'primeng/accordion';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputNumberModule } from 'primeng/inputnumber';
import { StepsModule } from 'primeng/steps';
import { DialogModule } from 'primeng/dialog';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { CheckboxModule } from 'primeng/checkbox';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { SelectButtonModule } from 'primeng/selectbutton';
import { InputSwitchModule } from 'primeng/inputswitch';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SidebarModule } from 'primeng/sidebar';
import { CardModule } from 'primeng/card';
import { InputMaskModule } from 'primeng/inputmask';
import { MultiSelectModule } from 'primeng/multiselect';
import { AutoCompleteModule } from 'primeng/autocomplete';

const modules = [
  DynamicDialogModule,
  ToastModule,
  ButtonModule,
  MenubarModule,
  TableModule,
  StyleClassModule,
  AccordionModule,
  ScrollPanelModule,
  CalendarModule,
  DropdownModule,
  InputTextareaModule,
  InputNumberModule,
  StepsModule,
  DialogModule,
  OverlayPanelModule,
  CheckboxModule,
  ProgressSpinnerModule,
  SplitButtonModule,
  ToggleButtonModule,
  SelectButtonModule,
  InputSwitchModule,
  ReactiveFormsModule,
  SidebarModule,
  CardModule,
  InputMaskModule,
  MultiSelectModule,
  FormsModule,
  AutoCompleteModule
];

@NgModule({
  declarations: [],
  imports: [...modules],
  exports: [...modules],
  providers: [DialogService],
})
export class PrimeNgModule {}
